<template>
  <section class="lg:relative absolute grid justify-center items-start place-content-center">
    <div
      class="py-6 flex flex-col justify-start fixed bg-white shadow-sm rounded-lg gap-6 w-24 place-content-center justify-self-center"
      style="height: 93%">
      <router-link class="flex relative items-center w-full justify-center cursor-pointer"
        :to="'/organization/' + orgData.slug + '/dashboard'">
        <img class="w-auto h-12 object-cover" src="@/assets/images/new-sidebar/icon.svg" />
      </router-link>

      <span class="w-auto bg-slate-100 mx-4 rounded-full xl:my-0 my-0" style="padding: 0.5px 0px"></span>

      <div class="flex relative items-center w-full justify-center flex-col xl:gap-6 gap-4">
        <vx-tooltip :text="$t('orgDashboard.sidebar.dashboard')" position="right" class="flex flex-col w-full">
          <router-link :to="'/organization/' + orgData.slug + '/dashboard'"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item"
            :class="activeRoute === 'org-home' ? 'sidebar__item__active' : ''">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                <path
                  d="M21.743 12.331L12.743 2.331C12.364 1.909 11.636 1.909 11.257 2.331L2.25698 12.331C2.12767 12.4747 2.04277 12.6527 2.01255 12.8436C1.98232 13.0345 2.00807 13.2301 2.08668 13.4067C2.16529 13.5833 2.29339 13.7333 2.45548 13.8386C2.61757 13.9439 2.8067 13.9999 2.99998 14H4.99998V21C4.99998 21.2652 5.10534 21.5196 5.29288 21.7071C5.48041 21.8946 5.73477 22 5.99998 22H18C18.2652 22 18.5196 21.8946 18.7071 21.7071C18.8946 21.5196 19 21.2652 19 21V14H21C21.1936 14.0008 21.3834 13.9453 21.546 13.8401C21.7087 13.735 21.8372 13.5848 21.916 13.4079C21.9947 13.231 22.0203 13.0349 21.9896 12.8437C21.9589 12.6525 21.8732 12.4744 21.743 12.331ZM12 16C11.2043 16 10.4413 15.6839 9.87866 15.1213C9.31605 14.5587 8.99998 13.7956 8.99998 13C8.99998 12.2043 9.31605 11.4413 9.87866 10.8787C10.4413 10.3161 11.2043 10 12 10C12.7956 10 13.5587 10.3161 14.1213 10.8787C14.6839 11.4413 15 12.2043 15 13C15 13.7956 14.6839 14.5587 14.1213 15.1213C13.5587 15.6839 12.7956 16 12 16Z"
                  fill="#FBB603" />
                <rect x="5" y="10" width="14" height="7" fill="#FBB603" />
                <circle cx="12" cy="17" r="3" fill="#737171" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M21.7427 12.3311L12.7427 2.33115C12.3637 1.90915 11.6357 1.90915 11.2567 2.33115L2.25674 12.3311C2.12743 12.4748 2.04253 12.6529 2.0123 12.8438C1.98208 13.0347 2.00783 13.2303 2.08644 13.4068C2.16505 13.5834 2.29315 13.7334 2.45523 13.8387C2.61732 13.944 2.80645 14.0001 2.99974 14.0001H4.99974V21.0001C4.99974 21.2654 5.1051 21.5197 5.29263 21.7073C5.48017 21.8948 5.73452 22 5.99974 22H17.9997C18.265 22.0001 18.5193 21.8948 18.7068 21.7073C18.8944 21.5197 18.9997 21.2654 18.9997 21.0001V14.0001H20.9997C21.1934 14.001 21.3831 13.9454 21.5458 13.8403C21.7084 13.7352 21.837 13.585 21.9157 13.408C21.9945 13.2311 22.0201 13.0351 21.9894 12.8439C21.9586 12.6527 21.873 12.4745 21.7427 12.3311ZM11.9997 16.0001C11.2041 16.0001 10.441 15.6841 9.87842 15.1215C9.31581 14.5589 8.99974 13.7958 8.99974 13.0001C8.99974 12.2045 9.31581 11.4414 9.87842 10.8788C10.441 10.3162 11.2041 10.0001 11.9997 10.0001C12.7954 10.0001 13.5584 10.3162 14.1211 10.8788C14.6837 11.4414 14.9997 12.2045 14.9997 13.0001C14.9997 13.7958 14.6837 14.5589 14.1211 15.1215C13.5584 15.6841 12.7954 16.0001 11.9997 16.0001Z"
                  fill="#737171" />
                <rect x="5" y="10" width="14" height="7" fill="#737171" />
                <circle cx="12" cy="17" r="3" fill="#FBB603" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">{{ $t('orgDashboard.sidebar.dashboard')
              }}</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip :text="$t('orgDashboard.sidebar.organizationDesign')" position="right" class="flex flex-col w-full">
          <router-link :to="'/organization/' + orgData.slug + '/plan'"
            :class="$route.path.includes('/plan') ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="absolute __hover">
                <path
                  d="M9 19C9 18.2044 8.68393 17.4413 8.12132 16.8787C7.55871 16.3161 6.79565 16 6 16C5.20435 16 4.44129 16.3161 3.87868 16.8787C3.31607 17.4413 3 18.2044 3 19C3 19.7956 3.31607 20.5587 3.87868 21.1213C4.44129 21.6839 5.20435 22 6 22C6.79565 22 7.55871 21.6839 8.12132 21.1213C8.68393 20.5587 9 19.7956 9 19ZM9 5C9 4.20435 8.68393 3.44129 8.12132 2.87868C7.55871 2.31607 6.79565 2 6 2C5.20435 2 4.44129 2.31607 3.87868 2.87868C3.31607 3.44129 3 4.20435 3 5C3 5.79565 3.31607 6.55871 3.87868 7.12132C4.44129 7.68393 5.20435 8 6 8C6.79565 8 7.55871 7.68393 8.12132 7.12132C8.68393 6.55871 9 5.79565 9 5ZM6 8V16Z"
                  fill="#FBB603" />
                <path
                  d="M6 16C6.79565 16 7.55871 16.3161 8.12132 16.8787C8.68393 17.4413 9 18.2044 9 19C9 19.7956 8.68393 20.5587 8.12132 21.1213C7.55871 21.6839 6.79565 22 6 22C5.20435 22 4.44129 21.6839 3.87868 21.1213C3.31607 20.5587 3 19.7956 3 19C3 18.2044 3.31607 17.4413 3.87868 16.8787C4.44129 16.3161 5.20435 16 6 16ZM6 16V8M6 8C5.20435 8 4.44129 7.68393 3.87868 7.12132C3.31607 6.55871 3 5.79565 3 5C3 4.20435 3.31607 3.44129 3.87868 2.87868C4.44129 2.31607 5.20435 2 6 2C6.79565 2 7.55871 2.31607 8.12132 2.87868C8.68393 3.44129 9 4.20435 9 5C9 5.79565 8.68393 6.55871 8.12132 7.12132C7.55871 7.68393 6.79565 8 6 8Z"
                  stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M18 13.5853C18 12.6533 18 12.602 17.848 12.235C17.7475 11.9922 17.6001 11.7716 17.4143 11.5857C17.2284 11.3999 17.0078 11.2525 16.765 11.152C16.398 11 15.932 11 15 11H9C8.068 11 7.602 11 7.235 10.848C6.99218 10.7475 6.77155 10.6001 6.58572 10.4143C6.3999 10.2285 6.25251 10.0078 6.152 9.76501C6 9.39801 6 8.93201 6 8.00001"
                  stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M17.9998 16.5307V22M20.7344 19.2654H15.2651" stroke="#FBB603" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6 16C6.79565 16 7.55871 16.3161 8.12132 16.8787C8.68393 17.4413 9 18.2044 9 19C9 19.7956 8.68393 20.5587 8.12132 21.1213C7.55871 21.6839 6.79565 22 6 22C5.20435 22 4.44129 21.6839 3.87868 21.1213C3.31607 20.5587 3 19.7956 3 19C3 18.2044 3.31607 17.4413 3.87868 16.8787C4.44129 16.3161 5.20435 16 6 16ZM6 16V8M6 8C5.20435 8 4.44129 7.68393 3.87868 7.12132C3.31607 6.55871 3 5.79565 3 5C3 4.20435 3.31607 3.44129 3.87868 2.87868C4.44129 2.31607 5.20435 2 6 2C6.79565 2 7.55871 2.31607 8.12132 2.87868C8.68393 3.44129 9 4.20435 9 5C9 5.79565 8.68393 6.55871 8.12132 7.12132C7.55871 7.68393 6.79565 8 6 8Z"
                  stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M18 13.5853C18 12.6533 18 12.602 17.848 12.235C17.7475 11.9922 17.6001 11.7716 17.4143 11.5857C17.2284 11.3999 17.0078 11.2525 16.765 11.152C16.398 11 15.932 11 15 11H9C8.068 11 7.602 11 7.235 10.848C6.99218 10.7475 6.77155 10.6001 6.58572 10.4143C6.3999 10.2285 6.25251 10.0078 6.152 9.76501C6 9.39801 6 8.93201 6 8.00001"
                  stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M17.9998 16.5307V22M20.7344 19.2654H15.2651" stroke="#737171" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>

            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip :text="$t('orgDashboard.sidebar.talentPool')" position="right" class="flex flex-col w-full">
          <router-link :to="'/organization/' + orgData.slug + '/talent-pool'"
            :class="activeRoute === 'org-users' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                <path d="M13.7656 6.11523L17.8845 10.2341" stroke="#FBB603" stroke-width="2" stroke-linecap="round" />
                <path d="M6.11719 13.7656L10.2361 17.8845" stroke="#FBB603" stroke-width="2" stroke-linecap="round" />
                <path d="M10.2361 6.11523L6.11719 10.2341" stroke="#FBB603" stroke-width="2" stroke-linecap="round" />
                <path d="M17.8845 13.7656L13.7656 17.8845" stroke="#FBB603" stroke-width="2" stroke-linecap="round" />
                <path
                  d="M12.0021 6.7044C13.302 6.7044 14.3558 5.65063 14.3558 4.35073C14.3558 3.05084 13.302 1.99707 12.0021 1.99707C10.7022 1.99707 9.64844 3.05084 9.64844 4.35073C9.64844 5.65063 10.7022 6.7044 12.0021 6.7044Z"
                  stroke="#FBB603" stroke-width="2" />
                <path
                  d="M12.0021 22.0032C13.302 22.0032 14.3558 20.9495 14.3558 19.6496C14.3558 18.3497 13.302 17.2959 12.0021 17.2959C10.7022 17.2959 9.64844 18.3497 9.64844 19.6496C9.64844 20.9495 10.7022 22.0032 12.0021 22.0032Z"
                  stroke="#FBB603" stroke-width="2" />
                <path
                  d="M4.35366 14.3538C5.65356 14.3538 6.70733 13.3 6.70733 12.0001C6.70733 10.7003 5.65356 9.64648 4.35366 9.64648C3.05377 9.64648 2 10.7003 2 12.0001C2 13.3 3.05377 14.3538 4.35366 14.3538Z"
                  stroke="#FBB603" stroke-width="2" />
                <path
                  d="M19.6427 14.3538C20.9426 14.3538 21.9964 13.3 21.9964 12.0001C21.9964 10.7003 20.9426 9.64648 19.6427 9.64648C18.3428 9.64648 17.2891 10.7003 17.2891 12.0001C17.2891 13.3 18.3428 14.3538 19.6427 14.3538Z"
                  stroke="#FBB603" stroke-width="2" />
                <path
                  d="M4.34605 13.0876C4.94706 13.0876 5.43428 12.6004 5.43428 11.9994C5.43428 11.3984 4.94706 10.9111 4.34605 10.9111C3.74503 10.9111 3.25781 11.3984 3.25781 11.9994C3.25781 12.6004 3.74503 13.0876 4.34605 13.0876Z"
                  fill="#737171" stroke="#737171" />
                <path
                  d="M12.0023 20.737C12.6033 20.737 13.0905 20.2498 13.0905 19.6488C13.0905 19.0478 12.6033 18.5605 12.0023 18.5605C11.4013 18.5605 10.9141 19.0478 10.9141 19.6488C10.9141 20.2498 11.4013 20.737 12.0023 20.737Z"
                  fill="#737171" stroke="#737171" />
              </svg>

              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.7656 6.11523L17.8845 10.2341" stroke="#737171" stroke-width="2" stroke-linecap="round" />
                <path d="M6.11719 13.7656L10.2361 17.8845" stroke="#737171" stroke-width="2" stroke-linecap="round" />
                <path d="M10.2361 6.11523L6.11719 10.2341" stroke="#737171" stroke-width="2" stroke-linecap="round" />
                <path d="M17.8845 13.7656L13.7656 17.8845" stroke="#737171" stroke-width="2" stroke-linecap="round" />
                <path
                  d="M12.0021 6.7044C13.302 6.7044 14.3558 5.65063 14.3558 4.35073C14.3558 3.05084 13.302 1.99707 12.0021 1.99707C10.7022 1.99707 9.64844 3.05084 9.64844 4.35073C9.64844 5.65063 10.7022 6.7044 12.0021 6.7044Z"
                  stroke="#737171" stroke-width="2" />
                <path
                  d="M12.0021 22.0032C13.302 22.0032 14.3558 20.9495 14.3558 19.6496C14.3558 18.3497 13.302 17.2959 12.0021 17.2959C10.7022 17.2959 9.64844 18.3497 9.64844 19.6496C9.64844 20.9495 10.7022 22.0032 12.0021 22.0032Z"
                  stroke="#737171" stroke-width="2" />
                <path
                  d="M4.35366 14.3538C5.65356 14.3538 6.70733 13.3 6.70733 12.0001C6.70733 10.7003 5.65356 9.64648 4.35366 9.64648C3.05377 9.64648 2 10.7003 2 12.0001C2 13.3 3.05377 14.3538 4.35366 14.3538Z"
                  stroke="#737171" stroke-width="2" />
                <path
                  d="M19.6427 14.3538C20.9426 14.3538 21.9964 13.3 21.9964 12.0001C21.9964 10.7003 20.9426 9.64648 19.6427 9.64648C18.3428 9.64648 17.2891 10.7003 17.2891 12.0001C17.2891 13.3 18.3428 14.3538 19.6427 14.3538Z"
                  stroke="#737171" stroke-width="2" />
                <path
                  d="M4.34605 13.0876C4.94706 13.0876 5.43428 12.6004 5.43428 11.9994C5.43428 11.3984 4.94706 10.9111 4.34605 10.9111C3.74503 10.9111 3.25781 11.3984 3.25781 11.9994C3.25781 12.6004 3.74503 13.0876 4.34605 13.0876Z"
                  fill="#FBB603" stroke="#FBB603" />
                <path
                  d="M12.0023 20.737C12.6033 20.737 13.0905 20.2498 13.0905 19.6488C13.0905 19.0478 12.6033 18.5605 12.0023 18.5605C11.4013 18.5605 10.9141 19.0478 10.9141 19.6488C10.9141 20.2498 11.4013 20.737 12.0023 20.737Z"
                  fill="#FBB603" stroke="#FBB603" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">{{ $t('orgDashboard.sidebar.talentPool')
              }}</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip :text="$t('orgDashboard.sidebar.reports')" position="right" class="flex flex-col w-full">
          <router-link :to="'/organization/' + orgData.slug + '/reports'"
            :class="activeRoute === 'org-reports' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="absolute __hover">
                <path
                  d="M9.99511 2.02103C7.49611 1.91603 5.56611 2.20303 5.56611 2.20303C4.34711 2.29103 2.01111 2.97303 2.01111 6.96503C2.01111 10.921 1.98611 15.799 2.01111 17.744C2.01111 18.932 2.74711 21.704 5.29311 21.852C8.38811 22.032 13.9631 22.071 16.5211 21.852C17.2051 21.813 19.4851 21.276 19.7731 18.796C20.0721 16.226 20.0131 14.441 20.0131 14.016"
                  stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M14.98 7.01605C14.98 7.01605 15.48 7.51605 15.98 8.51605C15.98 8.51605 17.569 6.01605 18.98 5.51605"
                  stroke="#FBB603" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.97998 13.0161H10.98M6.97998 17.0161H14.98" stroke="#FBB603" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M16.9947 12.0161C19.7597 12.0161 21.9997 9.77705 21.9997 7.01605C21.9997 6.35902 21.8703 5.70844 21.6187 5.10148C21.3671 4.49453 20.9983 3.94311 20.5335 3.47875C20.0687 3.01439 19.5169 2.6462 18.9097 2.39522C18.3025 2.14424 17.6518 2.0154 16.9947 2.01605C14.2307 2.01605 11.9897 4.25405 11.9897 7.01605C11.9897 7.67308 12.1192 8.32367 12.3708 8.93063C12.6224 9.53758 12.9912 10.089 13.456 10.5534C13.9208 11.0177 14.4726 11.3859 15.0798 11.6369C15.687 11.8879 16.3377 12.0167 16.9947 12.0161Z"
                  stroke="#FBB603" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>


              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.9801 7.01603C14.9801 7.01603 15.4801 7.51603 15.9801 8.51603C15.9801 8.51603 17.5691 6.01602 18.9801 5.51602M9.99511 2.02103C7.49611 1.91603 5.56611 2.20303 5.56611 2.20303C4.34711 2.29103 2.01111 2.97303 2.01111 6.96503C2.01111 10.921 1.98611 15.799 2.01111 17.744C2.01111 18.932 2.74711 21.704 5.29311 21.852C8.38811 22.032 13.9631 22.071 16.5211 21.852C17.2051 21.813 19.4851 21.276 19.7731 18.796C20.0721 16.226 20.0131 14.441 20.0131 14.016"
                  stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M6.97998 13.0161H10.98M6.97998 17.0161H14.98M22 7.01605C22 9.77705 19.76 12.0161 16.995 12.0161C16.338 12.0167 15.6872 11.8879 15.08 11.6369C14.4728 11.3859 13.921 11.0177 13.4562 10.5534C12.9914 10.089 12.6226 9.53758 12.3711 8.93063C12.1195 8.32367 11.99 7.67308 11.99 7.01605C11.99 4.25405 14.231 2.01605 16.995 2.01605C17.652 2.0154 18.3027 2.14424 18.9099 2.39522C19.5171 2.6462 20.0689 3.01439 20.5337 3.47875C20.9986 3.94311 21.3673 4.49453 21.6189 5.10148C21.8705 5.70844 22 6.35902 22 7.01605Z"
                  stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">{{ $t('orgDashboard.sidebar.reports')
              }}</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip :text="$t('orgDashboard.sidebar.recommendations')" position="right" class="flex flex-col w-full">
          <router-link :to="'/organization/' + orgData.slug + '/recommendations'"
            :class="$route.path.includes('/recommendations') ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="absolute __hover">
                <path
                  d="M11.9999 2.39844L14.8999 8.29844L21.4999 9.19844L16.7499 13.7984L17.7999 20.3984L11.9999 17.2984L6.19992 20.3984L7.24992 13.7984L2.49992 9.19844L9.09992 8.29844L11.9999 2.39844Z"
                  fill="#FBB603" />
                <path
                  d="M11.9999 2.39844V17.2984M11.9999 17.2984L6.19992 20.3984L7.24992 13.7984L2.49992 9.19844L9.09992 8.29844L11.9999 2.39844M11.9999 17.2984L17.7999 20.3984L16.7499 13.7984L21.4999 9.19844L14.8999 8.29844L11.9999 2.39844"
                  stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.5 11.3984C8 11.8984 9.6 12.8984 12 12.8984C14.4 12.8984 16 11.8984 16.5 11.3984"
                  stroke="#737171" stroke-width="1.5" stroke-linecap="round" />
              </svg>

              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.9999 2.39844L14.8999 8.29844L21.4999 9.19844L16.7499 13.7984L17.7999 20.3984L11.9999 17.2984L6.19992 20.3984L7.24992 13.7984L2.49992 9.19844L9.09992 8.29844L11.9999 2.39844Z"
                  fill="#737171" />
                <path
                  d="M11.9999 2.39844V17.2984M11.9999 17.2984L6.19992 20.3984L7.24992 13.7984L2.49992 9.19844L9.09992 8.29844L11.9999 2.39844M11.9999 17.2984L17.7999 20.3984L16.7499 13.7984L21.4999 9.19844L14.8999 8.29844L11.9999 2.39844"
                  stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.5 11.3984C8 11.8984 9.6 12.8984 12 12.8984C14.4 12.8984 16 11.8984 16.5 11.3984"
                  stroke="#FBB603" stroke-width="1.5" stroke-linecap="round" />
                <circle cx="12" cy="15.3984" r="1" fill="#FBB603" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">{{ $t('orgDashboard.sidebar.recommendations')
              }}</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip :text="$t('orgDashboard.sidebar.notifications')" position="right" class="flex flex-col w-full">
          <router-link :to="'/organization/' + orgData.slug + '/talent-pool'"
            :class="activeRoute === 'user-notifications' ? 'sidebar__item__active' : ''" class=" grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden
            sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path
                  d="M12 22C12.6193 22.0008 13.2235 21.8086 13.7285 21.4502C14.2335 21.0917 14.6143 20.5849 14.818 20H9.182C9.38566 20.5849 9.76648 21.0917 10.2715 21.4502C10.7765 21.8086 11.3807 22.0008 12 22ZM19 14.586V10C19 6.783 16.815 4.073 13.855 3.258C13.562 2.52 12.846 2 12 2C11.154 2 10.438 2.52 10.145 3.258C7.185 4.074 5 6.783 5 10V14.586L3.293 16.293C3.19996 16.3857 3.12617 16.4959 3.07589 16.6172C3.0256 16.7386 2.99981 16.8687 3 17V18C3 18.2652 3.10536 18.5196 3.29289 18.7071C3.48043 18.8946 3.73478 19 4 19H20C20.2652 19 20.5196 18.8946 20.7071 18.7071C20.8946 18.5196 21 18.2652 21 18V17C21.0002 16.8687 20.9744 16.7386 20.9241 16.6172C20.8738 16.4959 20.8 16.3857 20.707 16.293L19 14.586Z"
                  fill="#F2C244" />
                <path
                  d="M12 22C12.6193 22.0008 13.2235 21.8086 13.7285 21.4502C14.2335 21.0917 14.6143 20.5849 14.818 20H9.182C9.38566 20.5849 9.76648 21.0917 10.2715 21.4502C10.7765 21.8086 11.3807 22.0008 12 22Z"
                  fill="#737171" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 22C12.6193 22.0008 13.2235 21.8086 13.7285 21.4502C14.2335 21.0917 14.6143 20.5849 14.818 20H9.182C9.38566 20.5849 9.76648 21.0917 10.2715 21.4502C10.7765 21.8086 11.3807 22.0008 12 22ZM19 14.586V10C19 6.783 16.815 4.073 13.855 3.258C13.562 2.52 12.846 2 12 2C11.154 2 10.438 2.52 10.145 3.258C7.185 4.074 5 6.783 5 10V14.586L3.293 16.293C3.19996 16.3857 3.12617 16.4959 3.07589 16.6172C3.0256 16.7386 2.99981 16.8687 3 17V18C3 18.2652 3.10536 18.5196 3.29289 18.7071C3.48043 18.8946 3.73478 19 4 19H20C20.2652 19 20.5196 18.8946 20.7071 18.7071C20.8946 18.5196 21 18.2652 21 18V17C21.0002 16.8687 20.9744 16.7386 20.9241 16.6172C20.8738 16.4959 20.8 16.3857 20.707 16.293L19 14.586Z"
                  fill="#737171" />
                <path
                  d="M11.9977 22C12.617 22.0008 13.2211 21.8086 13.7262 21.4502C14.2312 21.0917 14.612 20.5849 14.8157 20H9.17969C9.38335 20.5849 9.76416 21.0917 10.2692 21.4502C10.7742 21.8086 11.3784 22.0008 11.9977 22Z"
                  fill="#FBB603" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">{{ $t('orgDashboard.sidebar.notifications')
              }}</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>
      </div>

      <div class="flex relative items-center w-full justify-end flex-col gap-2 h-full">
        <span class="w-full mx-4 rounded-full bg-slate-100" style="padding: 0.5px 0px"></span>
        <vx-tooltip :text="$t('Switch to User') || 'Switch to User'" position="right" class="flex flex-col w-full">
          <!-- Adjust the 'to' link below to your specific user dashboard route (e.g., '/' or '/user/dashboard') -->
          <router-link to="/user/dashboard"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              
              <!-- Hover State (Yellow User) -->
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute __hover">
                <path d="M20 21V19C20 16.7909 18.2091 15 16 15H8C5.79086 15 4 16.7909 4 19V21" stroke="#FBB603" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="12" cy="7" r="4" stroke="#FBB603" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

              <!-- Default State (Grey User) -->
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 21V19C20 16.7909 18.2091 15 16 15H8C5.79086 15 4 16.7909 4 19V21" stroke="#737171" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="12" cy="7" r="4" stroke="#737171" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">{{ $t('orgDashboard.sidebar.switchToUserSide') || 'Switch User' }}</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>
      </div>
        <!-- <vx-tooltip text="Settings" position="right" class="flex flex-col w-full">
          <router-link :to="'/organization/' + orgData.slug + '/admins'"
            :class="activeRoute === 'org-admins' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>
            <div class="flex justify-between items-center gap-3 w-fit">
              <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-slate-600 stroke-2" />
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip> -->
        <!-- Settings icon instead of Switch Org -->
        <!-- <vx-tooltip :text="$t('orgDashboard.sidebar.settings')" position="right" class="flex flex-col w-full">
          <router-link :to="{ name: 'org-settings' }"
            :class="activeRoute === 'org-settings' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <div class="icon-container">
                <feather-icon icon="SettingsIcon" class="" svgClasses="text-gray-700" />
              </div>
              <span class="text-base font-medium text-neutral-800 toggle">{{ $t('orgDashboard.sidebar.settings')
              }}</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip> -->
    </div>
  </section>
</template>

<script>
export default {
  name: "v-nav-menu",
  components: {},
  props: {},
  computed: {
    activeRoute() {
      return this.$route.name.toLowerCase();
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
  },
  created() {
    // if (this.isUserLoggedIn) {
    //   this.$store
    //     .dispatch("boards/fetchUserBoardData", this.$store.state.auth.user._id)
    //     .then((res) => {
    //       if (res.data) {
    //         this.organizationIds = res.data.boardData.organizationId;
    //       }
    //     })
    //     .catch((err) => {
    //       throw err;
    //     });
    // }
    // this.$store
    //   .dispatch("boards/fetchUserBoardData", this.$store.state.auth.user._id)
    //   .then((res) => { })
    //   .catch((err) => {
    //     throw err;
    //   });
    // this.$store
    //   .dispatch("users/fetchUser", this.$store.state.auth.user._id)
    //   .then((res) => {
    //     this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);
    //   });
  },
};
</script>

<style lang="scss">
.sidebar__item {
  cursor: pointer;

  .__hover {
    transition: all 0.1s ease-in;
    opacity: 0;
  }
}

.sidebar__item:hover {
  .__hover {
    opacity: 1;
  }
}

.sidebar__item__active {
  cursor: pointer;

  .__hover {
    transition: all 0.1s ease-in;
    opacity: 1;
  }
}

.toggle {
  display: none;
}

.active path {
  stroke: #ffcc00 !important;
}

/* Settings icon hover effect */
.sidebar__item:hover .hover-icon {
  opacity: 1 !important;
}

.sidebar__item:hover .regular-icon {
  opacity: 0;
}

.hover-icon,
.regular-icon {
  transition: opacity 0.2s ease;
}

.icon-container {
  position: relative;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-container .hover-icon,
.icon-container .regular-icon {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
